export const initialState = {
    user : null, 
    date : null, 
    time : null, 
    count : 0,
    mode : null,
}

export const reducer = (state, action) => {
    switch(action.type){
        case 'SET_USER' : 
            return {
                ...state,
                user : action.user
            }
        case 'SET_DATE' : 
            return {
                ...state,
                date : action.date
            }
        case 'SET_TIME' : 
            return {
                ...state,
                time : action.time
            }
        case 'INCREMENT_COUNT' : 
            return {
                ...state,
                count : action.count
            }
        case 'SET_MODE' : 
            return {
                ...state,
                mode : action.mode
            }
        default : 
            return state;
    }
}